import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  cart: [], // Array to store cart items
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addToCart: (state, action) => {
      // Check if the item already exists in the cart
      const { id, color, size, quantity } = action.payload;
      const existingItemIndex = state.cart.findIndex(item => 
          item.id === id &&
          item.color === color &&
          item.size === size);
      if (existingItemIndex !== -1) {
        // If it exists, update the quantity
        state.cart[existingItemIndex].quantity += quantity;
      } else {
        // If not, add it to the cart
        state.cart.push(action.payload);
      }
    },
    removeFromCart: (state, action) => {
      state.cart = state.cart.filter(item => item.id !== action.payload);
    },
    clearCart: (state) => {
      state.cart = [];
    },
    updateCartQuantity: (state, action) => {
      const { id, quantity, color, size } = action.payload;
      const itemIndex = state.cart.findIndex(item => 
        item.id === id &&
        item.color === color &&
        item.size === size);
      if (itemIndex !== -1) {
        state.cart[itemIndex].quantity = quantity;
      }
    },
  },
});

export const { addToCart, removeFromCart, clearCart, updateCartQuantity } = cartSlice.actions;

export default cartSlice.reducer;
